
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34112',
  depVersions: {
  "documents-public-ui": "static-1.34112",
  "client-types": "static-1.454",
  "documents-lib": "static-1.34117",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1986",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4884",
  "highcharts": "static-8.100",
  "hs-promise-utils": "static-1.5452",
  "hs-test-utils": "static-1.7866",
  "hub-http": "static-1.6076",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11302",
  "I18n": "static-7.1589",
  "jasmine-immutable": "static-1.2876",
  "jasmine-runner": "static-1.6329",
  "lodash": "static-1.3",
  "quartz": "static-1.6810",
  "react": "static-7.182",
  "react-dlb": "static-1.74",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.67",
  "react-rhumb": "static-1.16509",
  "reporting-data": "static-1.66771",
  "reporting-testing-lib": "static-1.8704",
  "reporting-visualizations": "static-1.58847",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4627",
  "webpack-env": "static-1.54",
  "atom": "static-1.4929",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2351",
  "classnames": "static-2.10",
  "cssUtils": "static-1.754",
  "customer-data-filters-ui": "static-1.39119",
  "customer-data-objects": "static-1.7511",
  "customer-data-property-utils": "static-1.7939",
  "data-fetching-client": "static-1.9536",
  "enviro": "static-4.416",
  "FireAlarmUi": "static-1.4388",
  "flux-actions": "static-1.317",
  "FormsCommonComponents": "static-1.85437",
  "FormUrlGenerator": "static-2.4580",
  "foundations-components": "static-1.7635",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3957",
  "HubStyle": "static-2.11610",
  "icons": "static-2.631",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7018",
  "metrics-js": "static-1.9436",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.377",
  "property-description-translator": "static-1.3715",
  "property-translator": "static-1.5269",
  "quartz-config": "static-1.588",
  "quartz-core": "static-1.6029",
  "quick-fetch": "static-1.3793",
  "raven": "static-3.5768",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5230",
  "react-virtualized": "static-2.95",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8022",
  "reference-resolvers-lite": "static-1.7944",
  "report-customization-components": "static-1.12685",
  "reporting-enablement": "static-1.22294",
  "reporting-reports": "static-1.66449",
  "reporting-snowflake": "static-1.55389",
  "reporting-ui-components": "static-2.64042",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4501",
  "sales-content-partitioning": "static-1.8795",
  "SalesContentIndexUI": "static-3.8994",
  "sanitize": "static-1.4333",
  "sanitize-text": "static-1.8004",
  "self-service-api": "static-1.10101",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1611",
  "signup-constants": "static-1.18518",
  "signup-ui-lego-core": "static-1.20528",
  "signup-ui-url-generator": "static-2.7893",
  "styled-components": "static-2.85",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4628",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10852",
  "ui-addon-i18n": "static-1.11003",
  "ui-addon-react-router-dom": "static-1.9404",
  "ui-addon-upgrades": "static-9.17744",
  "ui-asset-management-lib": "static-1.10792",
  "ui-images": "static-2.1114",
  "UIComponents": "static-3.8249",
  "usage-tracker": "static-1.7194",
  "usage-tracker-container": "static-1.7184",
  "usage-tracker-core": "static-1.7044",
  "usage-tracker-public": "static-1.7005",
  "viral-links-lib": "static-1.6897",
  "hs-promise-rejection-tracking": "static-1.5433",
  "raven-hubspot": "static-1.6075",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3285",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3087",
  "quartz-webpack": "static-1.3034",
  "ai-components-ui-library": "static-1.8529",
  "amplitude-session-replay-browser": "static-1.56",
  "foundations-assets": "static-1.4700",
  "foundations-theming": "static-1.4270",
  "quartz-auth": "static-1.485",
  "ui-business-units-lib": "static-1.8891",
  "usage-tracker-session-replay": "static-1.4880",
  "foundations-theming-base": "static-1.3255",
  "HeadJS": "static-2.724",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2977",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4185",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7783",
  "graphql": "static-1.78",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3475",
  "persist-promise": "static-1.3567",
  "reporting-client-types": "static-1.2403",
  "foundations-components-legacy": "static-1.660",
  "hs-story-utils": "static-1.9285",
  "react-flip-move": "static-1.66",
  "hub-http-shared-msw-handlers": "static-1.9621",
  "hubspotter-http": "static-1.4533",
  "sassPrefix": "static-1.153",
  "conversations-skeleton-state": "static-1.7107",
  "crm-message-bus": "static-1.42546",
  "customer-data-filters-ui-msw-helpers": "static-1.21554",
  "customer-data-objects-ui-components": "static-1.12871",
  "customer-data-reference-ui-components": "static-1.13007",
  "customer-data-ui-utilities": "static-1.9683",
  "framework-builder-read-service-client": "static-1.3888",
  "framework-data-schema-quick-fetch": "static-1.6637",
  "framework-data-schema-resolvers": "static-1.6732",
  "inbound-db-properties-service-client": "static-1.3726",
  "multi-account-reference-resolvers": "static-1.835",
  "onboarding-tours": "static-1.16345",
  "reporting-datasets-permissions-lib": "static-1.13229",
  "ui-addon-teams": "static-1.21324",
  "apollo-stack-hubspot": "static-3.82",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67804",
  "customer-data-properties": "static-1.50971",
  "forms-ai-lib": "static-1.4091",
  "forms-utils-lib": "static-1.12285",
  "foundations-components-test-utils": "static-1.5118",
  "react-dnd-compat": "static-1.4479",
  "react-tinymce": "static-1.54790",
  "tinymce-config": "static-2.53916",
  "ui-gdpr-components": "static-1.10207",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3904",
  "floating-ui": "static-1.52",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1369",
  "ui-fonts": "static-1.564",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.809",
  "mobile-manifest-mixins": "static-1.499",
  "module-federation": "static-1.19",
  "quartz-head": "static-1.475",
  "quartz-i18n": "static-1.485",
  "quartz-routing": "static-1.240",
  "quartz-test": "static-1.485",
  "quartz-tracking": "static-1.189",
  "batch-promise": "static-1.1410",
  "external-options-client-types": "static-1.4039",
  "react-colorpicker": "static-2.10070",
  "copilot-toolkit": "static-1.10687",
  "data-quality-ui-library": "static-1.12469",
  "html-to-image": "static-1.50",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6322",
  "reporting-action-components": "static-1.40811",
  "reporting-insights-lib": "static-1.1244",
  "reporting-plugins": "static-1.10052",
  "ui-addon-draggable-compat": "static-2.4113",
  "ui-addon-opt": "static-4.8242",
  "ui-shepherd-react": "static-3.10005",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24896",
  "hubspot-apollo-client": "static-1.4738",
  "chirp-fetch": "static-1.1742",
  "sales-templates-service-types-lib": "static-1.4047",
  "merchandise-lib": "static-1.261",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5571",
  "salesImages": "static-1.522",
  "ts-schema": "static-1.3960",
  "timezone-utils": "static-2.5103",
  "bender-build-tools": "static-1.3014",
  "chatspot-core": "static-1.20576",
  "bend-plugin-foundations-theming": "static-1.2753",
  "stylex": "static-1.28",
  "hubspotter-http-shared-msw-handlers": "static-1.9619",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3678",
  "crm-pipelines-api-client-types": "static-1.4020",
  "multi-currency-client-types": "static-1.3570",
  "getting-started-shared-tasks": "static-1.18047",
  "growth-data-modal": "static-1.5218",
  "growth-onboarding-confetti": "static-1.2931",
  "growth-onboarding-next-action-utils": "static-1.1453",
  "navigation-components": "static-1.17461",
  "onboarding-tours-client": "static-1.4559",
  "onboarding-tours-utils": "static-1.411",
  "ui-shepherd-tracker": "static-1.7386",
  "ui-universal-auth": "static-1.8781",
  "user-context": "static-1.4959",
  "cms-field-types": "static-1.4668",
  "content-icons-ui": "static-1.2178",
  "integrations-lib": "static-1.15613",
  "calling-global-api": "static-1.63911",
  "calling-internal-common": "static-1.31158",
  "calling-lifecycle-internal": "static-1.65293",
  "calling-lifecycle-messages": "static-1.57587",
  "commerce-products-lib": "static-1.9014",
  "crm-links": "static-1.6127",
  "file-manager-components": "static-1.23090",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.545",
  "inbounddb-objects-service-types": "static-1.4103",
  "meetings-icalendar-utils-lib": "static-1.491",
  "object-builder-ui-client": "static-1.48191",
  "pipeline-validation-client-types": "static-1.3844",
  "property-value-citations": "static-1.1585",
  "pulse": "static-1.382",
  "smart-property-lib": "static-1.6165",
  "tiered-pricing": "static-1.921",
  "ui-addon-iframeable": "static-1.8906",
  "final-form": "static-1.66",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19575",
  "tinymce-themes": "static-1.55886",
  "data-token-picker": "static-1.16147",
  "hub-http-contrib": "static-1.2902",
  "interframe": "static-3.4621",
  "tinymce-data": "static-1.40001",
  "tinymce-plugins": "static-1.57030",
  "ui-addon-sales-email": "static-1.5072",
  "magpie-lib": "static-1.5453",
  "magpie-types": "static-1.4913",
  "simple-logging-lib": "static-1.2909",
  "content-assistance-lib": "static-1.7531",
  "dashboard-lib": "static-1.80867",
  "ExportDialog": "static-6.10246",
  "hubspot-prosemirror": "static-1.17770",
  "hubspot-prosemirror-plugins": "static-1.17762",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8552",
  "campaign-roi-lib": "static-1.8458",
  "feedback-loader": "static-1.28986",
  "apollo-link-hub-http": "static-2.4510",
  "hubspot-apollo-cache": "static-1.197",
  "growth-monetization-service-types": "static-1.4358",
  "nav-client-types": "static-1.2216",
  "purchase-motions-api": "static-1.5574",
  "trials-service-types": "static-1.3759",
  "growth-onboarding-next-action-components": "static-1.1481",
  "user-context-client": "static-1.4477",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.584",
  "unified-auth-core-lib": "static-1.576",
  "getting-started-shared-tasks-store": "static-1.17165",
  "integrations-error-boundary-lib": "static-1.13028",
  "integrations-tracking-lib": "static-1.5449",
  "native-integrations-shared-strings": "static-1.7646",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10233",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31164",
  "shared-worker-versioning": "static-1.10898",
  "calling-usage-tracker": "static-1.6400",
  "voice-sms-access-library": "static-1.419",
  "customer-data-tracking": "static-1.6741",
  "commerce-permissions": "static-1.622",
  "products-iframe-lib": "static-1.7493",
  "products-ui-components-shared-msw-handlers": "static-1.10003",
  "location-customization-utils-lib": "static-1.8752",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.4013",
  "video-components-external": "static-1.10762",
  "video-data-lib": "static-1.34420",
  "directed-graph": "static-1.798",
  "event-emitter": "static-1.806",
  "fast-json-patch": "static-1.59",
  "breeze-intelligence-kit": "static-1.5405",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9704",
  "fsm": "static-1.3589",
  "policy-lib": "static-1.6637",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9767",
  "navigation-messaging": "static-1.6788",
  "FileManagerLib": "static-1.38730",
  "NamespacedHubStyle": "static-2.8950",
  "FileManagerCore": "static-1.38589",
  "codemirror": "static-5.91",
  "layout-dnd-components": "static-1.12156",
  "layout-dnd-utils": "static-1.11131",
  "react-codemirror": "static-1.10485",
  "ui-addon-emoji-picker": "static-1.9746",
  "ui-brand-identity-lib": "static-1.14305",
  "ui-addon-video-player": "static-1.8555",
  "ui-coaching-tips": "static-1.28102",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8417",
  "payment-link-components": "static-1.23095",
  "EmailSignatureEditor": "static-1.24014",
  "eligibility-engine-service-types": "static-1.3040",
  "universal-page-editor-lib": "static-1.2860",
  "calling-orchestration-schema": "static-1.35196",
  "sales-views-client-types": "static-1.4135",
  "crm-record-cards-service-types": "static-1.3497",
  "content-media-composition-data-lib": "static-1.11690",
  "content-media-compositions": "static-2.15697",
  "media-bridge-lib": "static-1.18669",
  "trellis-story-utils": "static-1.4379",
  "storybook-react": "static-1.29",
  "audio-components": "static-1.5695",
  "FileManagerImages": "static-1.36241",
  "video-components": "static-1.12765",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4390",
  "video-embed": "static-1.35254",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67879",
  "layout-data-lib": "static-1.9456",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6440",
  "commerce-tours-lib": "static-1.5811",
  "growth-onboarding-reliability": "static-1.4945",
  "sales-checkout-service-client": "static-1.3527",
  "draft-convert": "static-2.69",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.74",
  "draft-plugins": "static-2.21413",
  "sales-email-signature-service-client": "static-1.3702",
  "hls.js": "static-1.35",
  "social-insights-client-types": "static-1.21551",
  "outpost": "static-1.4059",
  "advanced-menus-core": "static-1.14901",
  "advanced-menus-lib": "static-1.11869",
  "ui-memberships-settings-lib": "static-1.33609",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14900",
  "simple-menus-lib": "static-1.16417"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34112",
  "client-types": "/client-types/static-1.454",
  "documents-lib": "/documents-lib/static-1.34117",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1986",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4884",
  "highcharts": "/highcharts/static-8.100",
  "hs-promise-utils": "/hs-promise-utils/static-1.5452",
  "hs-test-utils": "/hs-test-utils/static-1.7866",
  "hub-http": "/hub-http/static-1.6076",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11302",
  "I18n": "/I18n/static-7.1589",
  "jasmine-immutable": "/jasmine-immutable/static-1.2876",
  "jasmine-runner": "/jasmine-runner/static-1.6329",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6810",
  "react": "/react/static-7.182",
  "react-dlb": "/react-dlb/static-1.74",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.67",
  "react-rhumb": "/react-rhumb/static-1.16509",
  "reporting-data": "/reporting-data/static-1.66771",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8704",
  "reporting-visualizations": "/reporting-visualizations/static-1.58847",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4627",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4929",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2351",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.754",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39119",
  "customer-data-objects": "/customer-data-objects/static-1.7511",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7939",
  "data-fetching-client": "/data-fetching-client/static-1.9536",
  "enviro": "/enviro/static-4.416",
  "FireAlarmUi": "/FireAlarmUi/static-1.4388",
  "flux-actions": "/flux-actions/static-1.317",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85437",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4580",
  "foundations-components": "/foundations-components/static-1.7635",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyle": "/HubStyle/static-2.11610",
  "icons": "/icons/static-2.631",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7018",
  "metrics-js": "/metrics-js/static-1.9436",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "property-description-translator": "/property-description-translator/static-1.3715",
  "property-translator": "/property-translator/static-1.5269",
  "quartz-config": "/quartz-config/static-1.588",
  "quartz-core": "/quartz-core/static-1.6029",
  "quick-fetch": "/quick-fetch/static-1.3793",
  "raven": "/raven/static-3.5768",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5230",
  "react-virtualized": "/react-virtualized/static-2.95",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8022",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7944",
  "report-customization-components": "/report-customization-components/static-1.12685",
  "reporting-enablement": "/reporting-enablement/static-1.22294",
  "reporting-reports": "/reporting-reports/static-1.66449",
  "reporting-snowflake": "/reporting-snowflake/static-1.55389",
  "reporting-ui-components": "/reporting-ui-components/static-2.64042",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4501",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8795",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8994",
  "sanitize": "/sanitize/static-1.4333",
  "sanitize-text": "/sanitize-text/static-1.8004",
  "self-service-api": "/self-service-api/static-1.10101",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1611",
  "signup-constants": "/signup-constants/static-1.18518",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20528",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7893",
  "styled-components": "/styled-components/static-2.85",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4628",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10852",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11003",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9404",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17744",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10792",
  "ui-images": "/ui-images/static-2.1114",
  "UIComponents": "/UIComponents/static-3.8249",
  "usage-tracker": "/usage-tracker/static-1.7194",
  "usage-tracker-container": "/usage-tracker-container/static-1.7184",
  "usage-tracker-core": "/usage-tracker-core/static-1.7044",
  "usage-tracker-public": "/usage-tracker-public/static-1.7005",
  "viral-links-lib": "/viral-links-lib/static-1.6897",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3285",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3087",
  "quartz-webpack": "/quartz-webpack/static-1.3034",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8529",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4700",
  "foundations-theming": "/foundations-theming/static-1.4270",
  "quartz-auth": "/quartz-auth/static-1.485",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8891",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4880",
  "foundations-theming-base": "/foundations-theming-base/static-1.3255",
  "HeadJS": "/HeadJS/static-2.724",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2977",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4185",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7783",
  "graphql": "/graphql/static-1.78",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3475",
  "persist-promise": "/persist-promise/static-1.3567",
  "reporting-client-types": "/reporting-client-types/static-1.2403",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.660",
  "hs-story-utils": "/hs-story-utils/static-1.9285",
  "react-flip-move": "/react-flip-move/static-1.66",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9621",
  "hubspotter-http": "/hubspotter-http/static-1.4533",
  "sassPrefix": "/sassPrefix/static-1.153",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7107",
  "crm-message-bus": "/crm-message-bus/static-1.42546",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21554",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12871",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13007",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9683",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3888",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6637",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6732",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3726",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.835",
  "onboarding-tours": "/onboarding-tours/static-1.16345",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13229",
  "ui-addon-teams": "/ui-addon-teams/static-1.21324",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67804",
  "customer-data-properties": "/customer-data-properties/static-1.50971",
  "forms-ai-lib": "/forms-ai-lib/static-1.4091",
  "forms-utils-lib": "/forms-utils-lib/static-1.12285",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5118",
  "react-dnd-compat": "/react-dnd-compat/static-1.4479",
  "react-tinymce": "/react-tinymce/static-1.54790",
  "tinymce-config": "/tinymce-config/static-2.53916",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10207",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3904",
  "floating-ui": "/floating-ui/static-1.52",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1369",
  "ui-fonts": "/ui-fonts/static-1.564",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.809",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.499",
  "module-federation": "/module-federation/static-1.19",
  "quartz-head": "/quartz-head/static-1.475",
  "quartz-i18n": "/quartz-i18n/static-1.485",
  "quartz-routing": "/quartz-routing/static-1.240",
  "quartz-test": "/quartz-test/static-1.485",
  "quartz-tracking": "/quartz-tracking/static-1.189",
  "batch-promise": "/batch-promise/static-1.1410",
  "external-options-client-types": "/external-options-client-types/static-1.4039",
  "react-colorpicker": "/react-colorpicker/static-2.10070",
  "copilot-toolkit": "/copilot-toolkit/static-1.10687",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12469",
  "html-to-image": "/html-to-image/static-1.50",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6322",
  "reporting-action-components": "/reporting-action-components/static-1.40811",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1244",
  "reporting-plugins": "/reporting-plugins/static-1.10052",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4113",
  "ui-addon-opt": "/ui-addon-opt/static-4.8242",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10005",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24896",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4738",
  "chirp-fetch": "/chirp-fetch/static-1.1742",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4047",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5571",
  "salesImages": "/salesImages/static-1.522",
  "ts-schema": "/ts-schema/static-1.3960",
  "timezone-utils": "/timezone-utils/static-2.5103",
  "bender-build-tools": "/bender-build-tools/static-1.3014",
  "chatspot-core": "/chatspot-core/static-1.20576",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2753",
  "stylex": "/stylex/static-1.28",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9619",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3678",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4020",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3570",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18047",
  "growth-data-modal": "/growth-data-modal/static-1.5218",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2931",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1453",
  "navigation-components": "/navigation-components/static-1.17461",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4559",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.411",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7386",
  "ui-universal-auth": "/ui-universal-auth/static-1.8781",
  "user-context": "/user-context/static-1.4959",
  "cms-field-types": "/cms-field-types/static-1.4668",
  "content-icons-ui": "/content-icons-ui/static-1.2178",
  "integrations-lib": "/integrations-lib/static-1.15613",
  "calling-global-api": "/calling-global-api/static-1.63911",
  "calling-internal-common": "/calling-internal-common/static-1.31158",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65293",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57587",
  "commerce-products-lib": "/commerce-products-lib/static-1.9014",
  "crm-links": "/crm-links/static-1.6127",
  "file-manager-components": "/file-manager-components/static-1.23090",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.545",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4103",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.491",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48191",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3844",
  "property-value-citations": "/property-value-citations/static-1.1585",
  "pulse": "/pulse/static-1.382",
  "smart-property-lib": "/smart-property-lib/static-1.6165",
  "tiered-pricing": "/tiered-pricing/static-1.921",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8906",
  "final-form": "/final-form/static-1.66",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19575",
  "tinymce-themes": "/tinymce-themes/static-1.55886",
  "data-token-picker": "/data-token-picker/static-1.16147",
  "hub-http-contrib": "/hub-http-contrib/static-1.2902",
  "interframe": "/interframe/static-3.4621",
  "tinymce-data": "/tinymce-data/static-1.40001",
  "tinymce-plugins": "/tinymce-plugins/static-1.57030",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5072",
  "magpie-lib": "/magpie-lib/static-1.5453",
  "magpie-types": "/magpie-types/static-1.4913",
  "simple-logging-lib": "/simple-logging-lib/static-1.2909",
  "content-assistance-lib": "/content-assistance-lib/static-1.7531",
  "dashboard-lib": "/dashboard-lib/static-1.80867",
  "ExportDialog": "/ExportDialog/static-6.10246",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17770",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17762",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8552",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8458",
  "feedback-loader": "/feedback-loader/static-1.28986",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4510",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.197",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4358",
  "nav-client-types": "/nav-client-types/static-1.2216",
  "purchase-motions-api": "/purchase-motions-api/static-1.5574",
  "trials-service-types": "/trials-service-types/static-1.3759",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1481",
  "user-context-client": "/user-context-client/static-1.4477",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.584",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.576",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17165",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13028",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5449",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7646",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10233",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31164",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10898",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6400",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.419",
  "customer-data-tracking": "/customer-data-tracking/static-1.6741",
  "commerce-permissions": "/commerce-permissions/static-1.622",
  "products-iframe-lib": "/products-iframe-lib/static-1.7493",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10003",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8752",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.4013",
  "video-components-external": "/video-components-external/static-1.10762",
  "video-data-lib": "/video-data-lib/static-1.34420",
  "directed-graph": "/directed-graph/static-1.798",
  "event-emitter": "/event-emitter/static-1.806",
  "fast-json-patch": "/fast-json-patch/static-1.59",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5405",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9704",
  "fsm": "/fsm/static-1.3589",
  "policy-lib": "/policy-lib/static-1.6637",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9767",
  "navigation-messaging": "/navigation-messaging/static-1.6788",
  "FileManagerLib": "/FileManagerLib/static-1.38730",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8950",
  "FileManagerCore": "/FileManagerCore/static-1.38589",
  "codemirror": "/codemirror/static-5.91",
  "layout-dnd-components": "/layout-dnd-components/static-1.12156",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11131",
  "react-codemirror": "/react-codemirror/static-1.10485",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9746",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14305",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8555",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28102",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8417",
  "payment-link-components": "/payment-link-components/static-1.23095",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24014",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3040",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2860",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35196",
  "sales-views-client-types": "/sales-views-client-types/static-1.4135",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3497",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11690",
  "content-media-compositions": "/content-media-compositions/static-2.15697",
  "media-bridge-lib": "/media-bridge-lib/static-1.18669",
  "trellis-story-utils": "/trellis-story-utils/static-1.4379",
  "storybook-react": "/storybook-react/static-1.29",
  "audio-components": "/audio-components/static-1.5695",
  "FileManagerImages": "/FileManagerImages/static-1.36241",
  "video-components": "/video-components/static-1.12765",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4390",
  "video-embed": "/video-embed/static-1.35254",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67879",
  "layout-data-lib": "/layout-data-lib/static-1.9456",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6440",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5811",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4945",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3527",
  "draft-convert": "/draft-convert/static-2.69",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.74",
  "draft-plugins": "/draft-plugins/static-2.21413",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3702",
  "hls.js": "/hls.js/static-1.35",
  "social-insights-client-types": "/social-insights-client-types/static-1.21551",
  "outpost": "/outpost/static-1.4059",
  "advanced-menus-core": "/advanced-menus-core/static-1.14901",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11869",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33609",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14900",
  "simple-menus-lib": "/simple-menus-lib/static-1.16417"
}
};
